import { awaitRequests, promise, objectKeysToArray } from '../../../helpers';
import { getCourseAvailableLicensesBy, getCourseUsedLicensesBy } from '../courses-licenses';
import { getLearningCommunities } from './index';

const validateOnSaveLearningCommunity = item => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // -- courseLicenses validation
        const validateCoursesLicensesAvailability = () => {
            const { coursesLicenses, regionalEntityId } = item;

            if (coursesLicenses) {
                const reqs = objectKeysToArray(coursesLicenses).map(courseLicense => {
                    // --
                    const { id: courseLicenseId, courseId, corporateEntityId, licenses, courseName } = courseLicense;

                    const childReqs = [];

                    // get available licenses
                    childReqs.push(
                        dispatch(
                            getCourseAvailableLicensesBy({
                                by: 'regional-entity',
                                corporateEntityId,
                                courseId,
                                regionalEntityId,
                            }),
                        ),
                    );

                    // get used licenses
                    childReqs.push(
                        dispatch(
                            getCourseUsedLicensesBy({
                                filterBy: 'regional-entity',
                                courseId,
                                corporateEntityId,
                                courseLicenseId,
                            }),
                        ),
                    );

                    return awaitRequests(childReqs).then(res => {
                        // available
                        const availableLicenses = res[0];

                        // used
                        const usedLicenses = res[1];

                        // new compare value
                        const newUsedLicenses = usedLicenses + licenses;

                        if (newUsedLicenses > availableLicenses) {
                            return promise({
                                success: false,
                                courseName,
                            });
                        }

                        return promise({ success: true });
                    });
                });

                return awaitRequests(reqs).then(res => {
                    const filtered = res.filter(v => !v.success);

                    if (filtered.length) {
                        return promise({
                            success: false,
                            courseName: filtered[0].courseName,
                        });
                    }

                    return promise({ success: true });
                });
            }

            return promise({ success: true });
        };

        const { id: learningCommunityId, name, corporateEntityId, regionalEntityId } = item;

        const reqs = [];

        // learning communities data request for validation
        reqs.push(
            dispatch(
                getLearningCommunities({
                    where: [
                        ['name', '==', name],
                        ['corporateEntityId', '==', corporateEntityId],
                        ['regionalEntityId', '==', regionalEntityId],
                    ],
                }),
            ),
        );

        // courses licenses availability validation
        reqs.push(validateCoursesLicensesAvailability());

        return awaitRequests(reqs).then(res => {
            // learningCommunities
            const learningCommunities = res[0];

            if (learningCommunities.length) {
                // "is unique" validation
                const isUnique =
                    learningCommunities.filter(learningCommunity => {
                        if (learningCommunity.id === learningCommunityId) {
                            return false;
                        }

                        return true;
                    }).length === 0;

                if (!isUnique) {
                    return promise({
                        success: false,
                        errorMsg: 'La comunidad de aprendizaje y entidad regional enviados ya se encuentran registrados.',
                    });
                }
            }

            // courses licenses validation results
            const coursesLicensesValidation = res[1];

            if (coursesLicensesValidation) {
                // --
                if (!coursesLicensesValidation.success) {
                    // --
                    const { courseName } = coursesLicensesValidation;

                    return promise({
                        success: false,
                        errorMsg: `El curso '${courseName}' no cuenta con licencias disponibles.`,
                    });
                }
            }

            return promise({ success: true });
        });
    };
};

export default validateOnSaveLearningCommunity;
